"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _UGAVMSQJcjs = require('./UGAVMSQJ.cjs');


var _WMTGHDLEcjs = require('./WMTGHDLE.cjs');


var _4TRESXTOcjs = require('./4TRESXTO.cjs');

// src/menubar/menubar-store.ts
function createMenubarStore(props = {}) {
  var _a;
  const syncState = (_a = props.store) == null ? void 0 : _a.getState();
  const composite = _UGAVMSQJcjs.createCompositeStore.call(void 0, {
    ...props,
    orientation: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.orientation,
      syncState == null ? void 0 : syncState.orientation,
      "horizontal"
    ),
    focusLoop: _4TRESXTOcjs.defaultValue.call(void 0, props.focusLoop, syncState == null ? void 0 : syncState.focusLoop, true)
  });
  const initialState = {
    ...composite.getState()
  };
  const menubar = _WMTGHDLEcjs.createStore.call(void 0, initialState, composite, props.store);
  return {
    ...composite,
    ...menubar
  };
}



exports.createMenubarStore = createMenubarStore;
